// extracted by mini-css-extract-plugin
module.exports = {"transitHeader":"BrokerShipmentProfileRatesTable_transitHeader__YyOAb","methodHeader":"BrokerShipmentProfileRatesTable_methodHeader__2W8wH"};